/**
 * Shared input styling for Joy UI themes.
 *
 * This styling ensures consistent appearance of inputs across all themes:
 * - Placeholder text uses tertiary color with reduced opacity
 *
 * Note: For date inputs, always use the DateInput component from
 * modules/meridian/components/common/DateInput. The DateInput component
 * and global CSS (index.css) handle date input styling using data-empty
 * and data-typing attributes. Using a regular Input with type="date" will
 * not have the correct styling, making it obvious that DateInput should be used.
 */

/**
 * Shared placeholder styling for all input types
 */
export const placeholderStyles = {
  "&::placeholder": {
    color: "var(--joy-palette-text-tertiary)",
    opacity: 0.75,
  },
  "&::-webkit-input-placeholder": {
    color: "var(--joy-palette-text-tertiary)",
    opacity: 0.75,
  },
  "&::-moz-placeholder": {
    color: "var(--joy-palette-text-tertiary)",
    opacity: 0.75,
  },
  "&:-ms-input-placeholder": {
    color: "var(--joy-palette-text-tertiary)",
    opacity: 0.75,
  },
};
